import { useSelectorWithDispatch } from '@ers/hooks/';
import useTranslator from '@ers/translations/translator';
import { getForm } from './Form.selectors';
import { fetchApplicationDetails } from './Form.actions';

// eslint-disable-next-line import/prefer-default-export
export function useForm(applicationId) {
    const form = useSelectorWithDispatch(
        (state) => getForm(state, { applicationId }),
        () => fetchApplicationDetails(applicationId),
        (f) => !f
    );
    const translations = useTranslator((form || {}).formLanguageId);
    const isLoading = !form || !translations;
    return { isLoading, form, translations };
}